import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import viewbtn from "../Skills/images/iconoir_eye-solid.svg";
import { baseURL } from "../../config";

const MySkill = () => {
  const [posts, setPosts] = useState({ skills: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedSkill, setEditedSkill] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewSkill, setViewSkill] = useState(null);
  const [isManagerorHR, setIsManagerorHR] = useState(false);
  const id = localStorage.getItem("employeeid");
  const role = localStorage.getItem("userrole");
  useEffect(() => {
    setIsManagerorHR(
      role === "ROLE_MANAGER" ||
        role === "ROLE_SUPERVISOR" ||
        role === "ROLE_HR"
    );
  }, []);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        let strSkillsURL = `${baseURL}/skills`;
        if (
          role === "ROLE_MANAGER" ||
          role === "ROLE_SUPERVISOR" ||
          role === "ROLE_HR"
        ) {
          strSkillsURL = `${baseURL}/myskills?empid=` + id;
        }
        const { data } = await axios(strSkillsURL);
        console.log("Fetched data:", data);
        if (Array.isArray(data.skills)) {
          setPosts({ skills: data.skills });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleSaveEditedSkill = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/updateskill`,
        editedSkill
      );
      console.log("Updated Skill:", response.data);
      const updatedSkills = posts.skills.map((skill) => {
        if (skill.id === editedSkill.id) {
          return editedSkill;
        }
        return skill;
      });
      setPosts({ skills: updatedSkills });
      setShowEditModal(false);
    } catch (error) {
      console.error("Error updating Skill:", error);
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleEdit = (skill) => {
    setEditedSkill(skill);
    setShowEditModal(true);
  };

  const handleComment = (skill) => {
    setSelectedSkill(skill);
    setShowCommentModal(true);
  };

  const handleView = (skill) => {
    setViewSkill(skill);
    setShowViewModal(true);
  };

  const getProgressColor = (progress) => {
    if (progress <= 30) {
      return "danger";
    } else if (progress <= 60) {
      return "warning";
    } else {
      return "success";
    }
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.skills.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Created By</th>
            <th>Skill</th>
            <th>Skill Level</th>
            <th>Assignees</th>
            <th>Progress</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((skill, index) => (
            <tr key={index}>
              <td>{skill.id}</td>
              <td>{skill.creator_name}</td>
              <td>{skill.skillname}</td>
              <td>{skill.skilllevel}</td>
              <td>{skill.assignees}</td>
              <td>
                <ProgressBar
                  variant={getProgressColor(skill.progress)}
                  now={skill.progress}
                />
              </td>

              <td>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(skill)}
                >
                  <img src={Editbtn} alt="Edit" />
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleView(skill)}
                >
                  <img src={viewbtn} alt="View" />
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {showEditModal && editedSkill && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Edit Skill</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <div>
              <label>
                <b>Skill Name :</b>
              </label>
              <input
                className="border-0"
                type="text"
                value={editedSkill.skillname}
                onChange={(e) =>
                  setEditedSkill({ ...editedSkill, skillname: e.target.value })
                }
              />
            </div>

            <div>
              <label>
                <b>Justification :</b>
              </label>
              <input
                className="border-0"
                type="text"
                value={editedSkill.justification}
                onChange={(e) =>
                  setEditedSkill({
                    ...editedSkill,
                    justification: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Progress:</b>
              </label>
              <input
                className="border-0"
                type="text"
                value={editedSkill.progress}
                onChange={(e) =>
                  setEditedSkill({ ...editedSkill, progress: e.target.value })
                }
              />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedSkill}
            >
              Save Changes
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {showViewModal && viewSkill && (
        <ReactBootstrap.Modal
          show={showViewModal}
          onHide={handleCloseViewModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>View Skill</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <p>Title: {viewSkill.skillname}</p>
            <p>Skill Level: {viewSkill.skilllevel}</p>
            <p>Progress: {viewSkill.progress}</p>
            <p>Justification: {viewSkill.justification}</p>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseViewModal}
            >
              Close
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.skills.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index + 1}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default MySkill;
